/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  RotateHeartbeatTokenMutationResponse,
  RotateHeartbeatTokenPathParams,
  RotateHeartbeatToken401,
  RotateHeartbeatToken404,
} from '../types/RotateHeartbeatToken.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getRotateHeartbeatTokenUrl(id: RotateHeartbeatTokenPathParams['id']) {
  const res = { method: 'POST', url: `/v1/monitors/${id}/rotate-heartbeat-token` as const };
  return res;
}

/**
 * @summary Rotate the heartbeat token
 * {@link /v1/monitors/:id/rotate-heartbeat-token}
 */
export async function rotateHeartbeatToken(
  id: RotateHeartbeatTokenPathParams['id'],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    RotateHeartbeatTokenMutationResponse,
    ResponseErrorConfig<RotateHeartbeatToken401 | RotateHeartbeatToken404>,
    unknown
  >({ method: 'POST', url: getRotateHeartbeatTokenUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
